"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BCACardBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseReactComponents = require("@navinc/base-react-components");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _description = require("./description.js");

var _utils = require("@navinc/utils");

var _jsxRuntime = require("react/jsx-runtime");

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Image",
  componentId: "sc-1dyy9wu-0"
})(["max-width:100%;max-height:56px;width:auto;height:auto;"]);

var ApplyButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "ApplyButton",
  componentId: "sc-1dyy9wu-1"
})(["width:100%;height:auto;justify-content:space-around;"]);
var TitleCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "TitleCopy",
  componentId: "sc-1dyy9wu-2"
})(["margin-bottom:8px;@media (", "){margin-bottom:16px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.forLargerThanPhone;
});
var CenteredCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "CenteredCopy",
  componentId: "sc-1dyy9wu-3"
})(["text-align:center;"]);

var ImageBox = _styledComponents["default"].div.withConfig({
  displayName: "ImageBox",
  componentId: "sc-1dyy9wu-4"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;padding:16px;@media (", "){align-items:center;padding:24px;}& > ", "{margin-top:8px;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.forLargerThanPhone;
}, CenteredCopy);

var NonPartnerDisclosure = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "NonPartnerDisclosure",
  componentId: "sc-1dyy9wu-5"
})([""]);

var DetailBox = _styledComponents["default"].div.withConfig({
  displayName: "DetailBox",
  componentId: "sc-1dyy9wu-6"
})(["border-style:solid none none none;border-width:1px;border-color:", ";padding:16px 16px 0 16px;@media (", "){border-style:none none none solid;padding:24px;}& > ", "{margin-top:16px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.scuttleGray200;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.forLargerThanPhone;
}, NonPartnerDisclosure);

var ApplyBox = _styledComponents["default"].div.withConfig({
  displayName: "ApplyBox",
  componentId: "sc-1dyy9wu-7"
})(["padding:16px;@media (", "){padding:24px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.forLargerThanPhone;
});

var Grid = _styledComponents["default"].div.withConfig({
  displayName: "Grid",
  componentId: "sc-1dyy9wu-8"
})(["display:grid;grid-template-columns:1fr;grid-template-rows:auto auto auto;grid-template-areas:'image' 'detail' 'apply';@media (", "){grid-template-columns:200px 1fr;grid-template-rows:auto 1fr;grid-template-areas:'image detail' 'apply detail';}& > ", "{grid-area:image;}& > ", "{grid-area:detail;}& > ", "{grid-area:apply;align-self:self-end;& > ", "{margin-top:8px;}}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.forLargerThanPhone;
}, ImageBox, DetailBox, ApplyBox, CenteredCopy);

var applyButtonMap = {
  NAV: 'Open Account',
  PARTNER: 'Open Account',
  NON_PARTNER: 'Learn More'
};
var applyFinePrintMap = {
  NAV: '*On our secure site',
  PARTNER: "*On our partner's secure site",
  NON_PARTNER: '*On their website'
};

var Apply = function Apply(_ref7) {
  var _applyButtonMap$offer, _applyFinePrintMap$of;

  var offerOwner = _ref7.offerOwner,
      url = _ref7.url,
      onApplyTrack = _ref7.onApplyTrack;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ApplyBox, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyButton, {
      asAnchor: true,
      href: url,
      target: "_blank",
      rel: "noopener",
      "data-testid": "checking-account-card:apply-link",
      onClick: onApplyTrack,
      children: (_applyButtonMap$offer = applyButtonMap[offerOwner]) !== null && _applyButtonMap$offer !== void 0 ? _applyButtonMap$offer : applyButtonMap.NON_PARTNER
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CenteredCopy, {
      size: "xs",
      light: true,
      children: (_applyFinePrintMap$of = applyFinePrintMap[offerOwner]) !== null && _applyFinePrintMap$of !== void 0 ? _applyFinePrintMap$of : applyButtonMap.NON_PARTNER
    })]
  });
};

var BCACardBody = function BCACardBody() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      offer = _ref8.offer,
      order = _ref8.order,
      category = _ref8.category,
      locationUrl = _ref8.locationUrl,
      enterpriseUuid = _ref8.enterpriseUuid,
      referralName = _ref8.referralName,
      referralTarget = _ref8.referralTarget,
      referralType = _ref8.referralType,
      client = _ref8.client,
      _ref8$onApplyNow = _ref8.onApplyNow,
      onApplyNow = _ref8$onApplyNow === void 0 ? function () {} : _ref8$onApplyNow;

  var id = offer.id,
      name = offer.name,
      imageUrl = offer.imageUrl,
      url = offer.url,
      description = offer.description,
      rtid = offer.rtid,
      _offer$offerOwner = offer.offerOwner,
      offerOwner = _offer$offerOwner === void 0 ? 'PARTNER' : _offer$offerOwner;

  var trackNewTealiumConversion = function trackNewTealiumConversion() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      accountId: enterpriseUuid,
      offerCategory: 'checking-accounts',
      offerId: id,
      offerName: name,
      offerSubCategory: 'Banking',
      order: order,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: rtid,
      offerLink: url,
      partnerId: '',
      client: client,
      value: 0
    });
  };

  var onApplyTrack = function onApplyTrack() {
    trackNewTealiumConversion();
    onApplyNow();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Grid, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ImageBox, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Image, {
        src: imageUrl,
        alt: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CenteredCopy, {
        size: "xs",
        light: true,
        children: "Business Checking Account"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(DetailBox, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TitleCopy, {
        size: "lg",
        bold: true,
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_description.Description, {
        children: description
      }), offerOwner !== 'NAV' && offerOwner !== 'PARTNER' && /*#__PURE__*/(0, _jsxRuntime.jsx)(NonPartnerDisclosure, {
        size: "xs",
        light: true,
        "data-testid": "checking-account-card:non-partner-disclaimer",
        children: "*All information about the ".concat(name, " has been collected independently by Nav. This account is not currently available through Nav.")
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Apply, {
      offerOwner: offerOwner,
      url: url,
      onApplyTrack: onApplyTrack
    })]
  });
};

exports.BCACardBody = BCACardBody;
//# sourceMappingURL=body.js.map